import './en';



// WEBPACK FOOTER //
// ../../../.tmp/bs-moment/locale/index.ts